import { CSRF } from '../utils/CSRF'
import { BaseRepository } from './BaseRepository'

// Status mapping from Rails enum (Block::Segment model)
// Maps integer status values to their string representations
export const SEGMENT_STATUS_MAPPING = {
  0: 'never_started',
  1: 'finished',
  2: 'archived',
  3: 'processing',
  4: 'failed',
} as const

// Type for status keys
export type SegmentStatusKey = (typeof SEGMENT_STATUS_MAPPING)[keyof typeof SEGMENT_STATUS_MAPPING]

// Type for status values (integers)
export type SegmentStatusValue = keyof typeof SEGMENT_STATUS_MAPPING

export interface Segment {
  uuid: string
  status: SegmentStatusValue
  audio_src?: string
  voice_name?: string
  created_at: string
  updated_at: string
  last_generated_at?: string
  character_count?: number
  duration?: number // Duration in seconds from conversion
  pod_uuid: string
  pod_title?: string
  display_text?: string
  is_sts_request?: boolean
}

export interface SegmentsResponse {
  success: boolean
  items: Segment[]
  page: number
  page_size: number
  total_count: number
  num_pages: number
}

export class HistoryRepository extends BaseRepository {
  async getSegmentsViaConversions(page = 1, pageSize = 10) {
    const params = new URLSearchParams()
    params.append('page', Math.max(1, page).toString())
    params.append('page_size', pageSize.toString())

    const response = await super.getHttpClientInstance().get<SegmentsResponse>(`/api/v2/conversions/segments?${params.toString()}`, {
      'X-CSRF-Token': CSRF.getToken(),
      'Content-Type': 'application/json',
    })
    return response.data
  }
}
